export default "__VITE_ASSET__BDfcGy6v__"